import React, { createContext, useContext, useMemo } from 'react';
import { ethers } from 'ethers';
import { useWallet } from './WalletContext';
import { CONTRACTS } from '../config/contracts';
import CryptoPayABI from '../config/abi/CryptoPay.json';
import CryptoPayViewsABI from '../config/abi/CryptoPayViews.json';
import ERC20ABI from '../config/abi/ERC20.json';
import { CURRENT_NETWORK } from '../config/networks';

const ContractContext = createContext(null);
export const useContracts = () => useContext(ContractContext);

const fallbackProvider = () => new ethers.providers.JsonRpcProvider(CURRENT_NETWORK.rpcUrls[0]);

export function ContractProvider({ children }) {
  const { provider, signer, wrongNetwork } = useWallet();

  const value = useMemo(() => {
    const readProvider = provider && !wrongNetwork ? provider : fallbackProvider();
    const writeSigner = signer && !wrongNetwork ? signer : null;

    const main = new ethers.Contract(CONTRACTS.cryptoPay, CryptoPayABI, readProvider);
    const views = new ethers.Contract(CONTRACTS.cryptoPayViews, CryptoPayViewsABI, readProvider);
    const usdt = new ethers.Contract(CONTRACTS.usdt, ERC20ABI, readProvider);
    const token2 = new ethers.Contract(CONTRACTS.token2, ERC20ABI, readProvider);

    const mainW = writeSigner ? main.connect(writeSigner) : null;
    const viewsW = writeSigner ? views.connect(writeSigner) : null;
    const usdtW = writeSigner ? usdt.connect(writeSigner) : null;
    const token2W = writeSigner ? token2.connect(writeSigner) : null;

    return {
      main, views, usdt, token2,
      mainW, viewsW, usdtW, token2W,
      addresses: CONTRACTS
    };
  }, [provider, signer, wrongNetwork]);

  return <ContractContext.Provider value={value}>{children}</ContractContext.Provider>;
}
